import React, { useState } from 'react';

import {
  PopupWrap,
  CloseWrap,
} from './styled';

interface PopupInfoProps {
  text: string;
  subText?: string;
  subTextSecond?: string;
  className?: string;
  handleClose: () => void;
}

const PopupInfo = ({text, subText, subTextSecond, className, handleClose}: PopupInfoProps) => {
  return (
    <PopupWrap className={className}>
      <CloseWrap onClick={()=> handleClose()} />
      <p>{text}</p>
      <p>{subText}</p>
      <p>{subTextSecond}</p>
    </PopupWrap>
  );
};

export default PopupInfo;
